import { get } from 'lodash';

const pickBlogPostProperties = (item) => {
  const { id, link, slug, date, meta } = item;
  const title = get(item, 'title.rendered');
  const author = get(item, '_embedded.author[0].name');
  const content = get(item, 'content.rendered');
  const image = get(
    item,
    '_embedded.wp:featuredmedia[0].media_details.sizes.full.source_url'
  );
  const thumbnail = get(
    item,
    '_embedded.wp:featuredmedia[0].media_details.sizes.post-thumbnail.source_url'
  );

  return {
    id,
    link,
    slug,
    date,
    title,
    author,
    content,
    image,
    thumbnail,
    meta,
  };
};

export default pickBlogPostProperties;
